export class BuilderHelpers {
  static assignDefined<T extends object>(target: T, source: Partial<T> | undefined): T {
    if (!source) {
      return target;
    }

    for (const [key, value] of Object.entries(source)) {
      if (value !== undefined) {
        (target as Record<string, unknown>)[key] = value;
      }
    }

    return target;
  }

  static mapArray<T>(items: T[] | undefined | null, normalize: (item: T) => T, fallback: T[] = []): T[] {
    return (items ?? fallback).map(item => normalize(item));
  }
}
